import {
  CREATE_INVOICE_PAYMENT,
  CREATE_INVOICE_RECORD,
  DOWNLOAD_INVOICE,
  EDIT_INVOICE_RECORD,
  EMAIL_INVOICE,
  FETCH_INVOICE_DETAIL,
  FETCH_INVOICE_LIST_ERROR,
  FETCH_INVOICE_LIST_START,
  FETCH_INVOICE_LIST_SUCCESS,
  FETCH_INVOICE_PAYMENT_LIST_ERROR,
  FETCH_INVOICE_PAYMENT_LIST_START,
  FETCH_INVOICE_PAYMENT_LIST_SUCCESS,
  INIT_CREATE_NEW_INVOICE_SCREEN,
  INIT_INVOICE,
  INIT_INVOICE_PAYMENT,
  INVOICE_PAYMENT_MODE_DD,
  INVOICE_STATUS_FETCH_ERROR,
  INVOICE_STATUS_FETCH_START,
  INVOICE_STATUS_FETCH_SUCCESS,
  SEND_MULTIPLE_INVOICES,
  GENERATE_INVOICE,
  TOAST,
} from "../../../constants/action-types/invoice";

const formFieldValueMap = {
  id: 0,
  invoice_number: "",
  company_name: "",
  issued_date: null,
  due_date: null,
  start_date: null,
  end_date: null,
  status: "",
  total_amount: 0,
  amount_due: 0,
  currency: "",
};

export const INVOICE_ISSUE_DATE = "issued_date";
export const INVOICE_DUE_DATE = "due_date";
export const INVOICE_START_DATE = "start_date";
export const INVOICE_END_DATE = "end_date";
const isDateField = (key) => {
  const dateFields = [
    INVOICE_ISSUE_DATE,
    INVOICE_DUE_DATE,
    INVOICE_START_DATE,
    INVOICE_END_DATE,
  ];
  return dateFields.includes(key);
};

const INITIAL_STATE = {
  invoiceListView: [],
  invoiceStatuses: [],
  invoicePaymentList: [],
  isLoading: false,
  error: null,
  formFieldValueMap,
  fuelTransactionDtoList: [],
  isInvoiceSuccess: false,
  isInvoiceError: false,
  isInvoiceSuccess: false,
  isInvoiceError: false,
  isCreateInvoiceSuccess: false,
  isCreateInvoiceError: false,
  isEditInvoiceSuccess: false,
  isEditInvoiceError: false,
  isInvoiceDetailSuccess: false,
  isInvoiceDetailError: false,
  isDownloadSuccess: false,
  isDownloadError: false,
  isEmailSuccess: false,
  isEmailError: false,
  isCreateInvoicePaymentSuccess: false,
  isCreateInvoicePaymentError: false,
  invoicePaymentModeDD: {},
  isSendMultipleSuccess: false,
  isSendMultipleError: false,
};

export const invoiceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INIT_INVOICE:
    case INIT_INVOICE_PAYMENT:
      return { ...INITIAL_STATE, isLoadingPage: true };
    case FETCH_INVOICE_LIST_START:
    case FETCH_INVOICE_PAYMENT_LIST_START:
    case CREATE_INVOICE_RECORD.START:
    case EDIT_INVOICE_RECORD.START:
    case FETCH_INVOICE_DETAIL.START:
    case DOWNLOAD_INVOICE.START:
    case INVOICE_STATUS_FETCH_START:
    case EMAIL_INVOICE.START:
    case CREATE_INVOICE_PAYMENT.START:
    case INVOICE_PAYMENT_MODE_DD.START:
      return { ...state, isLoading: true };

    case FETCH_INVOICE_LIST_SUCCESS: {
      const { pageable, total_elements, content } = action.payload;

      let resetState = {
        invoiceListView: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
      };

      if (!content) {
        return resetState;
      }
      const { page_number, page_size } = pageable;

      return {
        ...resetState,
        invoiceListView: content,
        paginationInfo: {
          pageSize: page_size,
          pageNumber: page_number,
          totalPages: content.length,
          total_elements: total_elements,
        },
      };
    }
    case FETCH_INVOICE_LIST_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        invoiceListView: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
      };
    }
    case INIT_CREATE_NEW_INVOICE_SCREEN: {
      return { ...INITIAL_STATE };
    }
    case CREATE_INVOICE_RECORD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isCreateInvoiceSuccess: false,
        isCreateInvoiceError: true,
      };
    }
    case FETCH_INVOICE_DETAIL.SUCCESS: {
      const { invoice_dto, fuel_transaction_dto_list } = action.payload;

      const updatedFormFieldValueMap = {
        ...state.formFieldValueMap,
        invoice_number: invoice_dto?.invoice_number || "",
        id: invoice_dto.id || 0,
        company_name: invoice_dto?.company_name || "",
        issued_date: invoice_dto?.issued_date || null,
        due_date: invoice_dto?.due_date || null,
        start_date: invoice_dto?.start_date || null,
        end_date: invoice_dto?.end_date || null,
        status: invoice_dto?.status || "",
        total_amount: invoice_dto?.total_amount || 0,
        amount_due: invoice_dto?.amount_due || 0,
        currency: invoice_dto?.currency || "",
      };

      return {
        ...state,
        formFieldValueMap: updatedFormFieldValueMap,
        fuelTransactionDtoList: fuel_transaction_dto_list || [],
        isInvoiceDetailSuccess: true,
        isInvoiceDetailError: false,
        error: null,
        isLoading: false,
      };
    }
    case FETCH_INVOICE_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isInvoiceDetailSuccess: false,
        isInvoiceDetailError: true,
      };
    }
    case EDIT_INVOICE_RECORD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isEditInvoiceSuccess: false,
        isEditInvoiceError: true,
      };
    }
    case EDIT_INVOICE_RECORD.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isEditInvoiceSuccess: true,
        isEditInvoiceError: false,
      };
    }

    case DOWNLOAD_INVOICE.ERROR: {
      return {
        ...state,
        isLoading: false,
        isDownloadSuccess: false,
        isDownloadError: true,
      };
    }
    case DOWNLOAD_INVOICE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isDownloadSuccess: true,
        isDownloadError: false,
      };
    }
    case INVOICE_STATUS_FETCH_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        invoiceStatuses: action.payload,
      };
    }
    case INVOICE_STATUS_FETCH_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case EMAIL_INVOICE.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isEmailSuccess: true,
        isEmailError: false,
      };

    case EMAIL_INVOICE.ERROR:
      return {
        ...state,
        isLoading: false,
        isEmailSuccess: false,
        isEmailError: true,
      };

    case FETCH_INVOICE_PAYMENT_LIST_SUCCESS: {
      const { page,  content } = action.payload;

      let resetState = {
        invoicePaymentList: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
      };

      if (!content) {
        return resetState;
      }
      const { number, size, total_elements, total_pages } = page;

      return {
        ...resetState,
        invoicePaymentList: content,
        paginationInfo: {
          pageSize: size,
          pageNumber: number,
          totalPages: total_pages,
          total_elements: total_elements,
        },
      };
    }

    case FETCH_INVOICE_PAYMENT_LIST_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error: error,
      };
    }

    case CREATE_INVOICE_PAYMENT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isCreateInvoicePaymentSuccess: true,
        isCreateInvoicePaymentError: false,
      };
    }
    case CREATE_INVOICE_PAYMENT.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        isCreateInvoicePaymentSuccess: false,
        isCreateInvoicePaymentError: true,
        error,
      };
    }
    case INVOICE_PAYMENT_MODE_DD.SUCCESS: {
      const { content } = action.payload;
      return {
        ...state,
        isLoading: false,
        invoicePaymentModeDD: content,
      };
    }
    case INVOICE_PAYMENT_MODE_DD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case GENERATE_INVOICE.START:
      return { ...state, isLoading: true, isGenerateInvoiceSuccess: false, isGenerateInvoiceError: false };
    case GENERATE_INVOICE.SUCCESS:
      return { ...state, isLoading: false, isGenerateInvoiceSuccess: true, isGenerateInvoiceError: false, generateInvoiceResult: action.payload };
    case GENERATE_INVOICE.ERROR:
      return { ...state, isLoading: false, isGenerateInvoiceSuccess: false, isGenerateInvoiceError: true };
    case SEND_MULTIPLE_INVOICES.START:
      return { ...state, isLoading: true, isSendMultipleSuccess: false, isSendMultipleError: false };
    case SEND_MULTIPLE_INVOICES.SUCCESS:
      return { ...state, isLoading: false, isSendMultipleSuccess: true, isSendMultipleError: false };
    case SEND_MULTIPLE_INVOICES.ERROR:
      return { ...state, isLoading: false, isSendMultipleSuccess: false, isSendMultipleError: true };

    case TOAST.RESET: {
      return {
        ...state,
        isCreateInvoiceSuccess: false,
        isCreateInvoiceError: false,
        isEditInvoiceSuccess: false,
        isEditInvoiceError: false,
        isInvoiceDetailError: false,
        isDownloadSuccess: false,
        isDownloadError: false,
        isCreateInvoicePaymentSuccess: false,
        isCreateInvoicePaymentError: false,
        isSendMultipleSuccess: false,
        isSendMultipleError: false,
        isGenerateInvoiceSuccess: false,
        isGenerateInvoiceError: false,
      };
    }
    default:
      return state;
  }
};
